import type { Address } from '@/modules/address/domain/Address';
import environment from '@/modules/cart/environments/environment';
import httpClient from '@/modules/cart/services/api/client';
import type { Customer } from '@/modules/customer/domain/Customer';
import type { CustomerRepository } from '@/modules/customer/domain/CustomerRepository.ts';

const { CUSTOMERS } = environment;

const get = async (): Promise<Customer> => {
  return (await httpClient.get(`${CUSTOMERS}`)).data;
};

const saveAddress = async (address: Address): Promise<Customer> => {
  const response = await httpClient.post(`${CUSTOMERS}/address`, {
    ...address,
    country: 'CL',
    region: address.region.toString()
  });
  return response.data;
};

const updateAddress = async (address: Address): Promise<Customer> => {
  const response = await httpClient.patch(
    `${CUSTOMERS}/address/${address.id}`,
    {
      ...address,
      country: 'CL',
      region: address.region.toString()
    }
  );
  return response.data;
};

export const createCustomerRepository = (): CustomerRepository => ({
  get,
  saveAddress,
  updateAddress
});
